module.exports = __webpack_public_path__ + "static/media/PicnicBlue.c1190369.jpg";